import React from 'react';

export default function GreenUpArrowIcon(props) {
    return (
        <svg
            width="17"
            height="16"
            viewBox="0 0 17 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <rect x="0.333496" width="16" height="16" rx="8" fill="#D1FADF" />
            <path
                d="M8.3335 11.5V4.5M8.3335 4.5L4.8335 8M8.3335 4.5L11.8335 8"
                stroke={props.color || "#039855"}
                strokeWidth="1.25"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
}
